import { initElevarDataLayer } from '@/lib/elevar/shared';

export default function elevarSubscribe(customerEmail, customerPhone) {
  if (!initElevarDataLayer()) return;

  // Elevar recommends separate events per lead_type if both email and phone are provided
  if (customerEmail) {
    window.ElevarDataLayer.push({
      event: 'dl_subscribe',
      lead_type: 'email',
      user_properties: {
        customer_email: customerEmail,
      },
    });
  }

  if (customerPhone) {
    window.ElevarDataLayer.push({
      event: 'dl_subscribe',
      lead_type: 'phone',
      user_properties: {
        customer_phone: String(customerPhone),
      },
    });
  }
}
